<div class="container-graphs">
  <div class="half-graph heatmap" style="position: relative">
    <div
      class="graph-title"
      *ngIf="noHourData"
      style="position: absolute; left: 3rem; top: 1.5rem"
    >
      <h1>Horário</h1>
    </div>
    <button
      mat-icon-button
      #tooltip="matTooltip"
      matTooltip="Ocorrências por dia da semana e horário."
      matTooltipPosition="below"
      matTooltipHideDelay="100"
      style="position: absolute; left: 8rem; top: 1.3rem; z-index: 9999"
      aria-label="Button that displays a tooltip that hides when scrolled out of the container"
      class="info-icon"
    >
      <img src="assets/icons/questionTooltip.svg" alt="" />
    </button>
    <plotly-plot
      [data]="graph.data"
      [config]="graph.config"
      [layout]="graph.layout"
      *ngIf="!noHourData"
    ></plotly-plot>
    <div
      *ngIf="noHourData"
      style="
        width: 100%;
        height: 300px;
        margin: 5rem 2rem 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        border-radius: 16px;
        border: 2px dashed #c8bfff;

        color: #ab9fff;

        font-size: 1rem;
        font-weight: 400;
      "
    >
      <p>Não há dados suficientes para gerar o gráfico.</p>
    </div>
  </div>
  <div class="half-graph">
    <div class="graph">
      <div class="graph-title">
        <h1>Dias da semana</h1>
        <button
          mat-icon-button
          #tooltip="matTooltip"
          matTooltip="Ocorrências por dia da semana."
          matTooltipPosition="below"
          matTooltipHideDelay="100"
          aria-label="Button that displays a tooltip that hides when scrolled out of the container"
          class="info-icon"
        >
          <img src="assets/icons/questionTooltip.svg" alt="" />
        </button>
      </div>
      <canvas
        style="max-height: 300px"
        [id]="elId + 'myChartWeekDays'"
        *ngIf="!noWeekdayData"
      ></canvas>
      <div
        *ngIf="noWeekdayData"
        style="
          width: 100%;
          height: 300px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          border-radius: 16px;
          border: 2px dashed #c8bfff;

          color: #ab9fff;

          font-size: 1rem;
          font-weight: 400;
        "
      >
        <p>Não há dados suficientes para gerar o gráfico.</p>
      </div>
      <div
        *ngIf="!noWeekdayData"
        style="
          width: 100%;
          display: flex;
          gap: 30px;
          flex-wrap: wrap;
          justify-content: center;
          margin-top: 20px;
        "
      >
        <div style="display: flex; gap: 10px">
          <div
            [style.background]="'#180064'"
            style="width: 16px; height: 16px; border-radius: 4px"
          ></div>
          <p
            style="
              color: var(--material-theme-ref-neutral-neutral-60, #938f94);
              font-family: Roboto;
              font-size: 12px;
              font-style: normal;
              margin: 0;
              font-weight: 400;
              line-height: 16px;
            "
          >
            Domingo
          </p>
          <div
            [style.background]="'#2C009E'"
            style="width: 16px; height: 16px; border-radius: 4px"
          ></div>
          <p
            style="
              color: var(--material-theme-ref-neutral-neutral-60, #938f94);
              font-family: Roboto;
              font-size: 12px;
              font-style: normal;
              margin: 0;
              font-weight: 400;
              line-height: 16px;
            "
          >
            Segunda
          </p>
          <div
            [style.background]="'#5B43D9'"
            style="width: 16px; height: 16px; border-radius: 4px"
          ></div>
          <p
            style="
              color: var(--material-theme-ref-neutral-neutral-60, #938f94);
              font-family: Roboto;
              font-size: 12px;
              font-style: normal;
              margin: 0;
              font-weight: 400;
              line-height: 16px;
            "
          >
            Terça
          </p>
          <div
            [style.background]="'#8F7FFF'"
            style="width: 16px; height: 16px; border-radius: 4px"
          ></div>
          <p
            style="
              color: var(--material-theme-ref-neutral-neutral-60, #938f94);
              font-family: Roboto;
              font-size: 12px;
              font-style: normal;
              margin: 0;
              font-weight: 400;
              line-height: 16px;
            "
          >
            Quarta
          </p>
          <div
            [style.background]="'#C8BFFF'"
            style="width: 16px; height: 16px; border-radius: 4px"
          ></div>
          <p
            style="
              color: var(--material-theme-ref-neutral-neutral-60, #938f94);
              font-family: Roboto;
              font-size: 12px;
              font-style: normal;
              margin: 0;
              font-weight: 400;
              line-height: 16px;
            "
          >
            Quinta
          </p>
          <div
            [style.background]="'#5CDBBD'"
            style="width: 16px; height: 16px; border-radius: 4px"
          ></div>
          <p
            style="
              color: var(--material-theme-ref-neutral-neutral-60, #938f94);
              font-family: Roboto;
              font-size: 12px;
              font-style: normal;
              margin: 0;
              font-weight: 400;
              line-height: 16px;
            "
          >
            Sexta
          </p>
          <div
            [style.background]="'#006B58'"
            style="width: 16px; height: 16px; border-radius: 4px"
          ></div>
          <p
            style="
              color: var(--material-theme-ref-neutral-neutral-60, #938f94);
              font-family: Roboto;
              font-size: 12px;
              font-style: normal;
              margin: 0;
              font-weight: 400;
              line-height: 16px;
            "
          >
            Sabado
          </p>
        </div>
      </div>
    </div>
    <div class="graph">
      <div class="graph-title">
        <h1>Casos por turno</h1>
        <button
          mat-icon-button
          #tooltip="matTooltip"
          matTooltip="Ocorrências de acordo com os turnos do dia."
          matTooltipPosition="below"
          matTooltipHideDelay="100"
          aria-label="Button that displays a tooltip that hides when scrolled out of the container"
          class="info-icon"
        >
          <img src="assets/icons/questionTooltip.svg" alt="" />
        </button>
      </div>
      <canvas
        style="max-height: 300px"
        [id]="elId + 'myChartTurno'"
        *ngIf="!noTurnoData"
      ></canvas>

      <div
        *ngIf="noTurnoData"
        style="
          width: 100%;
          height: 300px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          border-radius: 16px;
          border: 2px dashed #c8bfff;

          color: #ab9fff;

          font-size: 1rem;
          font-weight: 400;
        "
      >
        <p>Não há dados suficientes para gerar o gráfico.</p>
      </div>
      <div
        *ngIf="!noTurnoData"
        style="
          width: 100%;
          display: flex;
          gap: 30px;
          flex-wrap: wrap;
          justify-content: center;
          margin-top: 20px;
        "
      >
        <div style="display: flex; gap: 10px">
          <div
            [style.background]="'#C8BFFF'"
            style="width: 16px; height: 16px; border-radius: 4px"
          ></div>
          <p
            style="
              color: var(--material-theme-ref-neutral-neutral-60, #938f94);
              font-family: Roboto;
              font-size: 12px;
              font-style: normal;
              margin: 0;
              font-weight: 400;
              line-height: 16px;
            "
          >
            Manhã
          </p>
          <div
            [style.background]="'#7E6CFE'"
            style="width: 16px; height: 16px; border-radius: 4px"
          ></div>
          <p
            style="
              color: var(--material-theme-ref-neutral-neutral-60, #938f94);
              font-family: Roboto;
              font-size: 12px;
              font-style: normal;
              margin: 0;
              font-weight: 400;
              line-height: 16px;
            "
          >
            Tarde
          </p>
          <div
            [style.background]="'#5B43D9'"
            style="width: 16px; height: 16px; border-radius: 4px"
          ></div>
          <p
            style="
              color: var(--material-theme-ref-neutral-neutral-60, #938f94);
              font-family: Roboto;
              font-size: 12px;
              font-style: normal;
              margin: 0;
              font-weight: 400;
              line-height: 16px;
            "
          >
            Noite
          </p>
          <div
            [style.background]="'#180064'"
            style="width: 16px; height: 16px; border-radius: 4px"
          ></div>
          <p
            style="
              color: var(--material-theme-ref-neutral-neutral-60, #938f94);
              font-family: Roboto;
              font-size: 12px;
              font-style: normal;
              margin: 0;
              font-weight: 400;
              line-height: 16px;
            "
          >
            Madrugada
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
